import { useState } from 'react';

import { useMarketplaceFilters, useMarketplaceProjects } from '@codes/marketplace/marketplace';
import { usePagination } from '@web/app/shared';

import {
    MarketplaceFilters,
    MarketplaceGrid,
    MarketplaceHeader,
    MarketplacePagination,
    ProjectDetailSheet,
} from '../components';

const ITEMS_PER_PAGE = 6;

export const MarketplacePage = () => {
    const { filters, page, updateFilters, setPage, clearFilters } = useMarketplaceFilters();
    const { data, isLoading } = useMarketplaceProjects(filters, page, ITEMS_PER_PAGE);
    const [selectedProjectId, setSelectedProjectId] = useState<string | null>(null);

    const projects = data?.projects || [];
    const totalCount = data?.total || 0;
    const totalPages = Math.ceil(totalCount / ITEMS_PER_PAGE);

    const { paginationRange } = usePagination({
        totalCount,
        pageSize: ITEMS_PER_PAGE,
        currentPage: page,
        siblingCount: 1,
    });

    const handleCategoryChange = (category: typeof filters.category) => {
        updateFilters({ category });
    };

    const handleSortChange = (sortBy: typeof filters.sortBy) => {
        updateFilters({ sortBy });
    };

    const handlePageChange = (newPage: number) => {
        setPage(newPage);
    };

    const handleViewDetails = (projectId: string) => {
        setSelectedProjectId(projectId);
    };

    return (
        <>
            <div className="w-full py-10 px-[43px] max-md:p-5">
                <MarketplaceHeader />

                <MarketplaceFilters
                    category={filters.category}
                    sortBy={filters.sortBy}
                    totalCount={totalCount}
                    onCategoryChange={handleCategoryChange}
                    onSortChange={handleSortChange}
                />

                <MarketplaceGrid
                    projects={projects}
                    isLoading={isLoading}
                    onViewDetails={handleViewDetails}
                    hasFilters={filters.category !== 'all' || filters.sortBy !== 'recent'}
                    onClearFilters={clearFilters}
                />

                <MarketplacePagination
                    currentPage={page}
                    totalPages={totalPages}
                    totalCount={totalCount}
                    limit={ITEMS_PER_PAGE}
                    paginationRange={paginationRange}
                    onPageChange={handlePageChange}
                />
            </div>

            <ProjectDetailSheet
                projectId={selectedProjectId}
                open={!!selectedProjectId}
                onOpenChange={open => !open && setSelectedProjectId(null)}
            />
        </>
    );
};
